// @ts-expect-error tinymce not typed
import tinymce from 'tinymce';
import http from 'hub-http/clients/apiClient';
import { getAppUrl } from 'rich-text-lib/utils/getAppUrl';
import { getStaticUrl, getStaticPrefix } from 'rich-text-lib/utils/staticUrl';

// @ts-expect-error CANVAS_INLINE not typed
import { CANVAS_INLINE } from 'tinymce-themes/themes/canvas-inline';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/autoresize';
import 'tinymce-plugins/hscore';
import 'tinymce-plugins/hspersonalize';
import 'tinymce-plugins/hsdatatokens';
import 'tinymce-plugins/hsemoji';
import 'tinymce-plugins/hsescapenewlines';
import { INLINE_TARGET_FORMAT_CONFIG } from 'tinymce-plugins/constants/inlineTarget';
import { hsPersonalizeConfig } from 'tinymce-plugins/constants/hspersonalize';
import { hsDataTokenConfig } from 'tinymce-plugins/constants/hsdatatokens';
import { HS_INPAGE, HS_PLUGINS } from 'tinymce-plugins/constants/hsSettings';
import { HS_CORE, HS_PERSONALIZE, HS_DATA_TOKEN, HS_EMOJI, HS_ESCAPE_NEWLINES } from 'tinymce-plugins/constants/plugins';
import { getGated } from '../../utils/auth';
import { HS_FLEXIBLE_ASSOCIATIONS_GATE } from '../../Constants';
import { personalizationFieldCoreSchema, personalizationFieldMultilineSchema } from '../../schemas/personalization-field';
const GatedMap = {
  [HS_FLEXIBLE_ASSOCIATIONS_GATE]: {
    flag: 'useFlexibleAssociations'
  }
};

// Make sure that the base URL used to fetch localizations and plugins
// that haven't been added to the bundle is correct.
tinymce.baseURL = getStaticUrl('tinymce', '/js/tinymce');
export const getConfig = (options = {}) => {
  const {
    trackInteraction,
    usageTracker,
    appName,
    appUrl = getAppUrl(),
    gates,
    hideTokenFallbacks = true,
    allowEmptyTokenFallbacks = false,
    includeInternalContactRecord,
    includeSiteSettings = true,
    includeSubscriptionType = true,
    isEmail = false,
    isRtl,
    supportedCrmObjectFQNs = [],
    customObjectPrefixes = {},
    enableEmoji = false,
    pickerComponents,
    placeholder,
    isMultiline = true,
    isEscapeNewlines = false,
    useDataTokens = false,
    dataTokenContext,
    unsupportedTokens,
    unsupportedDataTokenPaths,
    useDefaultLabelForCrmObjectTypes = false,
    maxTokenWidth
  } = options;
  let tokensPlugin;
  if (useDataTokens) {
    tokensPlugin = HS_DATA_TOKEN;
  } else {
    tokensPlugin = HS_PERSONALIZE;
  }
  const basePlugins = ['autoresize', 'paste', HS_CORE, tokensPlugin];
  const gated = getGated(GatedMap, gates);
  if (enableEmoji) {
    basePlugins.push(HS_EMOJI);
  }
  if (isEscapeNewlines) {
    basePlugins.push(HS_ESCAPE_NEWLINES);
  }
  const plugins = [...basePlugins, ...gated.plugins].join(' ');
  const {
    useFlexibleAssociations = false
  } = gated.flags;
  const schemas = [personalizationFieldCoreSchema];
  if (isMultiline) {
    schemas.push(personalizationFieldMultilineSchema);
  }
  return {
    appUrl,
    forced_root_block: false,
    apiClient: http,
    skin: false,
    statusbar: false,
    menubar: false,
    // Use custom set of valid elements so that only the HTML elements that are supported
    // via the TinyMCE UI are allowed in the content
    valid_elements: schemas.join(','),
    browser_spellcheck: true,
    plugins,
    inline: true,
    theme: CANVAS_INLINE,
    content_css: getStaticUrl('tinymce-themes', '/bundles/personalization-field.css'),
    toolbar: [],
    canvasToolbar: undefined,
    paste_as_text: true,
    autoresize_bottom_margin: 0,
    paste_data_images: true,
    formats: {
      hsInlineTarget: INLINE_TARGET_FORMAT_CONFIG
    },
    placeholder,
    directionality: isRtl ? 'rtl' : 'ltr',
    [HS_INPAGE]: false,
    [HS_PLUGINS]: {
      richTextLibStaticPrefix: getStaticPrefix('rich-text-lib'),
      trackInteraction,
      usageTracker,
      isEmail,
      appName,
      pickerComponents,
      [tokensPlugin]: {
        [hsPersonalizeConfig.HIDE_SITE_SETTINGS_CATEGORY]: !includeSiteSettings,
        [hsPersonalizeConfig.INCLUDE_SUBSCRIPTION_TYPE_CATEGORY]: includeSubscriptionType,
        [hsPersonalizeConfig.SUPPORTED_CRM_OBJECT_FQNS]: supportedCrmObjectFQNs,
        [hsPersonalizeConfig.CUSTOM_OBJECT_PREFIXES]: customObjectPrefixes,
        [hsPersonalizeConfig.INCLUDE_INTERNAL_CONTACT_RECORD]: isEmail && includeInternalContactRecord,
        [hsPersonalizeConfig.ALLOW_EMPTY_FALLBACKS]: allowEmptyTokenFallbacks,
        [hsPersonalizeConfig.IS_EMAIL]: isEmail,
        [hsPersonalizeConfig.HIDE_FALLBACKS]: hideTokenFallbacks,
        [hsPersonalizeConfig.USE_FLEXIBLE_ASSOCIATIONS]: useFlexibleAssociations,
        [hsPersonalizeConfig.TOKEN_PATHS_CONTEXT]: dataTokenContext,
        [hsPersonalizeConfig.UNSUPPORTED_TOKENS]: unsupportedTokens,
        [hsDataTokenConfig.UNSUPPORTED_DATA_TOKEN_PATHS]: unsupportedDataTokenPaths,
        [hsDataTokenConfig.USE_DEFAULT_LABEL_FOR_CRM_OBJECT_TYPES]: useDefaultLabelForCrmObjectTypes,
        [hsDataTokenConfig.MAX_TOKEN_WIDTH]: maxTokenWidth
      }
    },
    gates
  };
};